module.exports = __webpack_public_path__ + "static/media/undraw_mobile_encryption_re_yw3o.49dbae81.svg";